import React from 'react'
import CarePlanManagement from './Management/CarePlansManagement'

const CarePlansWrapper = ({ isMonitoring }) => {
  return <CarePlanManagement isMonitoring={isMonitoring} />
}

export default CarePlansWrapper
